<template>
    <div class="period-stepper">
        <button type="button" class="period-arrow period-arrow-left" @click="changePeriod(-1)"
            :disabled="!canChangePeriod(-1)">
            <b-icon icon="chevron-left" font-scale="1" />
        </button>
    
        <div class="period-display" v-b-tooltip.hover title="Period">
            {{ currentPeriodText }}
        </div>
    
        <button type="button" class="period-arrow period-arrow-right" @click="changePeriod(1)"
            :disabled="!canChangePeriod(1)">
            <b-icon icon="chevron-right" font-scale="1" />
        </button>
    </div>
</template>

<script>
export default {
  name: 'PeriodStepper',
  props: {
    selectedPeriod: {
      type: String,
      required: true
    },
    periodOptions: {
      type: Array,
      required: true
    }
  },
  computed: {
    currentPeriodText() {
      const currentOption = this.periodOptions.find((option) => option.value === this.selectedPeriod);
      return currentOption ? currentOption.text.replace(" m.", " months") : "3 months";
    }
  },
  methods: {
    changePeriod(direction) {
      const currentIndex = this.periodOptions.findIndex((option) => option.value === this.selectedPeriod);
      const newIndex = currentIndex + direction;

      if (newIndex >= 0 && newIndex < this.periodOptions.length) {
        const newPeriod = this.periodOptions[newIndex].value;
        console.log("PeriodStepper: Period changed to", newPeriod);
        this.$emit('period-changed', newPeriod);
      }
    },

    canChangePeriod(direction) {
      const currentIndex = this.periodOptions.findIndex((option) => option.value === this.selectedPeriod);
      const newIndex = currentIndex + direction;
      return newIndex >= 0 && newIndex < this.periodOptions.length;
    }
  }
}
</script>

<style scoped>
.period-stepper {
    display: flex;
    align-items: center;
    background: white;
    border-radius: 0.25rem;
    border: 1px solid #17a2b8;
    /* цвет как у outline-info кнопок */
    overflow: hidden;
    height: 31px;
    /* Высота как у кнопок size="sm" */
    min-width: 160px;
    max-width: 160px;
    padding: 0;
}

.period-stepper.disabled {
    opacity: 0.5;
    pointer-events: none;
    border-color: #6c757d;
}

.period-arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 100%;
    border: none;
    background: transparent;
    color: #17a2b8;
    /* цвет как у outline-info кнопок */
    cursor: pointer;
    transition: background-color 0.15s ease-in-out;
    outline: none !important;
    box-shadow: none !important;
}

.period-arrow:hover:not(:disabled) {
    background: #17a2b8;
    color: white;
}

.period-arrow:disabled {
    color: #dee2e6;
    cursor: not-allowed;
}

.period-arrow-left {
    border-right: 1px solid #dee2e6;
}

.period-arrow-right {
    border-left: 1px solid #dee2e6;
}

.period-display {
    flex: 1;
    text-align: center;
    padding: 0.25rem 0.5rem;
    font-weight: 400;
    color: #17a2b8;
    /* цвет как у outline-info кнопок */
    background: white;
    font-size: 0.875rem;
    line-height: 1.5;
    white-space: nowrap;
}
</style>
